<template>
  <div id="app">
    <div>
      <div id="pageZero" class="pageZero" ref="pageZero"
        :style="{ width: '100%', height: 'auto', display: 'flex', flexDirection: 'column' }">

        <div style="position: fixed;z-index: 100;width: 100%;">
          <div class="pnavigation">
            <img src="./assets/img/logo.png" class="plogo" />
            <div :class="{ selectTitle: isSelect(1), unSelectTitle: isUnSelect(1), marginLeft240: true }"
              @click="changeTabStatus(1)">
              Home
            </div>
            <div :class="{ selectTitle: isSelect(2), unSelectTitle: isUnSelect(2), marginLeft68: true }"
              @click="changeTabStatus(2)">
              Products solution
            </div>
            <div :class="{ selectTitle: isSelect(3), unSelectTitle: isUnSelect(3), marginLeft68: true }"
              @click="changeTabStatus(3)">
              Service and support
            </div>
            <div :class="{ selectTitle: isSelect(4), unSelectTitle: isUnSelect(4), marginLeft68: true }"
              @click="changeTabStatus(4)">
              About us
            </div>
            <div :class="{ selectTitle: isSelect(5), unSelectTitle: isUnSelect(5), marginLeft68: true }"
              @click="showReport()">
              Member center
            </div>

            <a :class="{ selectTitle: isSelect(5), unSelectTitle: isUnSelect(5), marginLeft68: true }" href="https://mqcgm.com/" target="_self">
              中文官网
            </a>
          </div>
          <div style="width: 100%;height: 1px;background-color: #e8e8e8;">

          </div>
        </div>


        <div class="pnavigation" ref="pnavigation">
          <img src="./assets/img/logo.png" class="plogo" />
          <div :class="{ selectTitle: isSelect(1), unSelectTitle: isUnSelect(1), marginLeft240: true }"
            @click="changeTabStatus(1)">
            Home
          </div>
          <div :class="{ selectTitle: isSelect(2), unSelectTitle: isUnSelect(2), marginLeft68: true }"
            @click="changeTabStatus(2)">
            Products solution
          </div>
          <div :class="{ selectTitle: isSelect(3), unSelectTitle: isUnSelect(3), marginLeft68: true }"
            @click="changeTabStatus(3)">
            Service and support
          </div>
          <div :class="{ selectTitle: isSelect(4), unSelectTitle: isUnSelect(4), marginLeft68: true }"
            @click="changeTabStatus(4)">
            About us
          </div>
          <div :class="{ selectTitle: isSelect(5), unSelectTitle: isUnSelect(5), marginLeft68: true }"
            @click="showReport()">
            Member center
          </div>
        </div>


      </div>

      <div v-if="tabStatus == 1">
        <div class="pswiper">

          <swiper ref="mySwiper" :options="swiperOptions">
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg1.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg2.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg3.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>
            <swiper-slide class="height867" :style="{ height: calcuHeight }">
              <div class="slide-item">
                <img src="./assets/img/bg4.png" class="img_bg" />
                <img src="./assets/img/next.png" class="icon123" @click="pagingDown" />
              </div>
            </swiper-slide>

            <!-- 分页指示器，如果需要的话 -->
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>

        <div class="padding1" :style="{ width: '100%', height: fullHeight, display: 'flex' }" id="pageOne"
          ref="pageOne">
          <div ref="mmm">
            <div style="display: flex;">
              <div class="width534">
                <div class="title36">
                  Huzhou Meiqi Medical Instruments Co., Ltd.
                </div>
                <div class="content11">
                  Huzhou Meiqi Medical Devices Co., Ltd. was established in September 2009, with its headquarters located in Huzhou, Zhejiang Province. It has been successively rated as a national high-tech enterprise and a high-tech enterprise R&D center of Zhejiang Province. The company is undertaking a key national scientific research project titled "Research on Early Warning and Systematic Intervention Measures for the Development of Abnormal Sub-Health State of Glucose and Lipid Metabolism".
                </div>
                <div class="content11">
                  The company adheres to the goal of "quality oriented, caring for health" to protect human health with outstanding scientific research results and innovative products.
                </div>
                <div class="knowmore" style="background-image: url('static/img/knowmore.png');"
                  @click="changeTabStatus(4)">
                  Learn more >
                </div>
              </div>
              <img src="./assets/img/mg1.png" class="pic1" />
            </div>
            <div style="display: flex;justify-content: space-between;" class="top80">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;">
                  <div class="title72">
                    2009
                  </div>
                </div>
                <div class="title38">
                  founded
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    97
                  </div>
                </div>
                <div class="title38">
                  patents
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    16
                  </div>
                </div>
                <div class="title38">
                  countries
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    2000+
                  </div>
                </div>
                <div class="title38">
                  hospitals
                </div>
              </div>

              <div style="display: flex;flex-direction: column;align-items: center;">
                <div style="display: flex;flex-direction: row;align-items: end;">
                  <div class="title72">
                    250
                  </div>
                  <div class="title16">
                    k
                  </div>
                </div>
                <div class="title38">
                  users
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">F
          <div style="display: flex;width: 100%;height: 100%;background-color: #F8F8F8;">
            <img src="./assets/img/system.png" class="width1212" />

            <div class="width333e">
              <div class="title36">
                Meiqi continuous glucose monitoring system
              </div>
              <div class="content14e top30">
                The Meiqi RGMS continuous blood glucose monitoring system adopts a monitoring mode similar to a "blood glucose dynamic recorder" to achieve 24-hour continuous dynamic monitoring of patients' blood glucose levels.
              </div>
              <div class="content14e top18">
                System Composition: Biological sensing unit, intelligent terminal device (including professional application program), wireless signal transmission module, data management and analysis platform
              </div>
              <div class="content14e top18">
               Working Principle: Based on the principle of glucose oxidation reaction in subcutaneous interstitial fluid, the biological sensor converts chemical signals into electrical signals, which are processed and transmitted in real time through intelligent algorithms. The system collects data once every 10 seconds, generates dynamic blood glucose values every 3 minutes, It provides 480 readings throughout the day forms a visual blood glucose graph, and supports real-time viewing on multiple terminals and tracing of historical data.
              </div>
              <div style="background-image: url('static/img/knowmore.png');cursor: pointer;" class="width150"
                @click="changeTabStatus(2)">
                Learn more >
              </div>
            </div>
          </div>
        </div>

      </div>

      <div v-if="tabStatus == 2">
        <div style="background-image: url('static/img/bg_2.png');width: 100%;background-size: cover; "
          class=" padding293" :style="{ height: fullHeight }">
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">
          <div style="display: flex;width: 100%;height: 100%;background-color: #F8F8F8;">
            <img src="./assets/img/bg_2_2.png" class="width1212" />

            <div class="width425">
              <div class="px311">
                Better control your life and dynamically manage your blood sugar.
              </div>
              <div class="xxx1 top36">
                Track dynamically throughout the day to obtain comprehensive blood sugar data.
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  Synchronize with the App in real time, and dynamically display the blood sugar curve and trend
                  changes.
                </div>
              </div>

              <div class="xxx1 top24">
                Intelligent integration of data and dynamic management.
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  It supports the recording of diet, exercise and medication use, intelligently generates personalized
                  suggestions and risk warnings.
                </div>
              </div>

              <div class="xxx1 top24">
                Provide blood glucose analysis and clinical auxiliary support.
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  Comprehensive blood glucose data analysis is helpful for clinical auxiliary support.
                </div>
              </div>

              <div class="top30" style="display: flex;flex-direction: column;">
                <div style="display: flex;flex-direction: row;">
                  <img src="./assets/img/z1.png" class="zpic" />
                  <div class="zword">
                    Glucose trend analysis
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top18">
                  <img src="./assets/img/z2.png" class="zpic" />
                  <div class="zword">
                    Assessment of the food Impact
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top18">
                  <img src="./assets/img/z3.png" class="zpic" />
                  <div class="zword">
                    Risk Warning
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top18">
                  <img src="./assets/img/z4.png" class="zpic" />
                  <div class="zword">
                    Optimization of Treatment Plans
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">
          <div style="display: flex;width: 100%;height: 100%;background-color: #F8F8F8;">


            <div class="width447">
              <div class="px311">
                Meiqi Central Monitoring System
              </div>
              <div class="xxx1 top36">
                Real-time monitoring of the whole hospital, data interconnection
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  The nurse station centrally monitors the dynamic blood glucose data of patients. To realize the
                  information management of the department and grasp the trend of blood sugar change at any time.
                </div>
              </div>

              <div class="xxx1 top24">
                Professional reporting system, dynamic blood sugar control
              </div>
              <div style="display: flex;" class="xxx2">
                <div class="point">
                </div>
                <div class="xxx3" style="flex: 1;">
                  Provide continuous dynamic charts, statistical key indicators, to generate personalized blood sugar
                  control recommendations.
                </div>
              </div>

              <div class="top30" style="display: flex;flex-direction: column;">
                <div style="display: flex;flex-direction: row;">
                  <img src="./assets/img/z5.png" class="zpic" />
                  <div class="zword">
                    Hospital - wide Blood Glucose Management
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top18">
                  <img src="./assets/img/z6.png" class="zpic" />
                  <div class="zword">
                    Dynamic Statistics of Indicators
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top18">
                  <img src="./assets/img/z7.png" class="zpic" />
                  <div class="zword">
                    Real - time Abnormality Warnings
                  </div>
                </div>
                <div style="display: flex;flex-direction: row;" class="top18">
                  <img src="./assets/img/z8.png" class="zpic" />
                  <div class="zword">
                    Enhance Clinical Efficiency
                  </div>
                </div>
              </div>
            </div>

            <img src="./assets/img/bg_2_3.png" class="width1212" />

          </div>
        </div>

        <div
          :style="{ width: '100%', height: fullHeight, display: 'flex', alignItems: 'center', justifyContent: 'center' }"
          id="pageFive" ref="pageFive">
          <img src="./assets/img/bg_2_4.png" class="width1478" />
        </div>

        <div
          :style="{ width: '100%', height: fullHeight, display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#F5FAFF' }"
          id="pageFive" ref="pageFive">
          <div class="title36top90">
            Easy and comfortable
          </div>
          <div class="top12title24">
            Please refer to the video tutorial
          </div>
          <video src="../static/wear.mp4" class="width1200" controls />
        </div>

        <div
          :style="{ width: '100%', height: fullHeight, display: 'flex', flexDirection: 'column', alignItems: 'center', background: '#FFFFFF' }"
          id="pageFive" ref="pageFive">
          <div class="title36top90">
            Real-time monitoring and protection
          </div>
          <div class="top12title24">
            Enjoy the new page of glucose monitoring with Meiqi CGM
          </div>
          <div class="top90">
            <div style="display: flex;align-items: center;flex-direction: column;">
              <img src="./assets/img/bg_2_6.png" class="width354" />
              <div class="things">
                7:00 breakfast
              </div>
            </div>

            <div style="display: flex;align-items: center;flex-direction: column;" class="left20">
              <img src="./assets/img/bg_2_7.png" class="width354" />
              <div class="things">
                9:00 work
              </div>
            </div>

            <div style="display: flex;align-items: center;flex-direction: column;" class="left20">
              <img src="./assets/img/bg_2_8.png" class="width354" />
              <div class="things">
                119:00 movement
              </div>
            </div>

            <div style="display: flex;align-items: center;flex-direction: column;margin-left: 20px;">
              <img src="./assets/img/bg_2_9.png" class="width354" />
              <div class="things">
                22:30 Sleep
              </div>
            </div>

          </div>
          <img src="./assets/img/bg_2_10.png" class="height70">
        </div>

        <div :style="{ height: fullHeight }"
          style="background-image: url('static/img/bg_2_15.png');width: 100%;background-size: cover; display: flex;align-items: center;flex-direction: column;"
          class="padding293 top100">
          <div class="px32">
            Safeguards your health scientifically, and cares across distance.
          </div>
          <div class="px33">
            You could remotely follow the real-time glucose monitoring data of your family members.

          </div>
        </div>


      </div>

      <div v-if="tabStatus == 3">
        <div class="height867r" id="pageFive">
          <div style="background-image: url('static/img/bg_3_1.png');" class="height472">
            <div class="left221">
              <div>
                <div class="title50">
                  Our efforts,
                </div>
                <div class="title50">
                  your satisfaction.
                </div>
              </div>
              <div class="subtitle24">
                Focus on health, worthy of trust.
              </div>
            </div>
          </div>

        </div>


        <div :style="{ width: '100%', height: fullHeight, display: 'flex', }" id="pageFive" ref="pageFive">
          <div style="display: flex;align-items: center;flex-direction: column;width: 100%;"
            :style="{ height: fullHeight }">
            <div class="f36t130">
              App download
            </div>
            <div class="f24t12">
              Search for the corresponding APP name in the major mobile app market to download
            </div>
            <div style="display: flex;" class="top48">

            </div>
            <div style="display: flex;">
              <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
                <img src="./assets/img/bg_3_2.png" class="height393" />
                <div class="f24t16">
                  MQ CGM
                </div>
                <div class="f16t8">
                  Main push version - comprehensive features
                </div>
              </div>

              <div
                style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 28px;">
                <img src="./assets/img/bg_3_3.png" class="height393" />
                <div class="f24t16">
                  MQ Mini
                </div>
                <div class="f16t8">
                  Designed for seniors, easy to read and simple to use
                </div>
              </div>

              <div
                style="display: flex;flex-direction: column;align-items: center;justify-content: center;margin-left: 28px;">
                <img src="./assets/img/bg_3_4.png" class="height393" />
                <div class="f24t16">
                  MQ Doctor
                </div>
                <div class="f16t8">
                  Patient management, doctor-patient communication
                </div>
              </div>
            </div>


          </div>
        </div>

        <div id="pageFive" ref="pageFive" :style="{ height: fullHeight }"
          style="display: flex;flex-direction: column;align-items: center;width: 100%;background-color:#F5FAFF;">
          <div style="display: flex;align-items: center;flex-direction: column;width: 100%;"
            :style="{ height: fullHeight }">
            <div class="f36t130">
              Service
            </div>
            <div class="f24t12">
              Contact Us
            </div>
            <div style="display: flex;flex-direction: column;" class="top48">
              <div style="display: flex;flex-direction: row;">
                <div class="unknow">
                  <img src="./assets/img/bg_3_10.png" class="t36h82w82" />
                  <div class="f24t18">
                    Customer Service Hotline
                  </div>
                  <div class="f16t8">
                    400-0572-278
                  </div>
                </div>

                <div class="unknow left28">
                  <img src="./assets/img/bg_3_11.png" class="t36h82w82" />
                  <div class="f24t18">
                    Address
                  </div>
                  <div class="f16t8">
                    Building 5, No.58 Yuchi Road,
                  </div>
                  <div class="f16">
                    Huzhou, Zhejiang, China.
                  </div>
                </div>

                <div class="unknow left28">
                  <img src="./assets/img/bg_3_12.png" class="t36h82w82" />
                  <div class="f24t18">
                    Business contact
                  </div>
                  <div class="f16t8">
                    Tel: 13567983061

                  </div>
                  <div class="f16">
                    Email：lym@mqcgm.com
                  </div>
                </div>
              </div>

              <div style="display: flex;flex-direction: row;" class="top28">
                <div class="unknow2">
                  <img src="./assets/img/bg_3_14.png" class="px1" />
                  <div class="px2">
                    Scan code to follow Meiqi public number
                    Enjoy fast and convenient service
                  </div>
                  <img src="./assets/img/bg_3_15.png" class="px3" />
                </div>
              </div>
            </div>


          </div>
        </div>

        <div id="pageFive" ref="pageFive" class="px4" :style="{ height: fullHeight }">
          <div>
            <div class="f36">
              General FAQs
            </div>
          </div>
          <a-input class="px7" placeholder="Search keywords" v-model="sParams.question" @keydown.enter="getList">
            <a-icon slot="prefix" type="search" />
          </a-input>

          <a-collapse accordion class="px8" :expand-icon-position="expandIconPosition" :bordered="false">
            <a-collapse-panel :key="index" :header="item.question" v-for="(item, index) in QAList" :style="customStyle">
              <p class="px9">{{ item.solution }}</p>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </div>

      <div v-if="tabStatus == 4">
        <div style="background-image: url('static/img/bg_4_1_1.png');" class="px10">
          <div>
            <div class="px11">
              Focus on the continuous glucose data management
            </div>
          </div>
          <div class="px12">
            Dedicated to the health management of diabetes patients, focusing on quality and caring for health.
          </div>
        </div>

        <div :style="{ width: '100%', height: fullHeight, display: 'flex' }" id="pageFive" ref="pageFive">
          <div
            style="display: flex;width: 100%;height: 100%;background-color: #FFFFFF;flex-direction: column;align-items: center;">



            <div class="f36h50 top56">
              Huzhou Meiqi Medical Instruments Co., Ltd.
            </div>

            <div class="content12">
              Huzhou Meiqi Medical Devices Co., Ltd. was established in September 2009, with its headquarters located in Huzhou, Zhejiang Province. It has been successively rated as a national high-tech enterprise and a high-tech enterprise R&D center of Zhejiang Province. The company is undertaking a key national scientific research project titled "Research on Early Warning and Systematic Intervention Measures for the Development of Abnormal Sub-Health State of Glucose and Lipid Metabolism".
            </div>
            <div class="content12">
              Cooperating with the Chinese Academy of Sciences and Zhejiang University, Meiqi has a R&D management team of more than 100 people, including professors, scientists from world-renowned universities, hospitals and IT elites. Based on modern pharmaceutics, biochemistry, artificial intelligence and other high technologies, we develop and produce real-time dynamic blood glucose monitoring systems and artificial pancreas. The first generation of Meiqi CGM was released in China in 2013. The company has a complete industrial chain including R&D, manufacture, sales and service, and has complete automated production lines with annual production capacity of 20 million sets of sensors. The company adheres to the goal of "quality oriented, caring for health" to protect human health with outstanding scientific research results and innovative products.
            </div>

            <img src="./assets/img/bg_4_2_3.png" class="top20" />

            <div style="display: flex;" class="top66">
              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c1.png" class="c1" />
                <div class="c2">
                  Company Vision
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  To become the leader of China's real - time dynamic blood glucose intelligent monitoring industry.
                </div>
              </div>

              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c2.png" class="c1" />
                <div class="c2">
                  Company Mission
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  Dedicate to the health management of diabetes patients.
                </div>
              </div>

              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c3.png" class="c1" />
                <div class="c2">
                  Company Values
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  Base on integrity, and reach far with innovation.
                </div>
              </div>

              <div style="display: flex;flex-direction: column;">
                <img src="./assets/img/c4.png" class="c1" />
                <div class="c2">
                  Company principle
                </div>
                <div class="title38 c3" style="margin-top: 0px;">
                  Focus on quality and care for health.
                </div>
              </div>

            </div>

          </div>
        </div>

        <div id="pageFive" ref="pageFive" :style="{ height: fullHeight }"
          style="background-image: url('static/img/bg_4_3.png');" class="px14">
          <div class="px15">
            Our history
          </div>
        </div>

        <div id="pageFive" ref="pageFive" class="px26" :style="{ height: fullHeight }">
          <div>
            <div class="f36h50">
              Qualifications and Honors
            </div>
          </div>
          <div class="px27">
            As a national high-tech enterprise and a provincial-level specialized, sophisticated, distinctive and innovative enterprise, we have established an independent intellectual property system covering the entire industrial chain. In the field of core technologies, we have cumulatively applied for 29 invention patents (13 of which have been granted), 41 utility model patents (32 of which have been granted), 13 design patents (12 of which have been granted), and hold 40 software copyright certificates, forming a multi-dimensional and three-dimensional portfolio of technical assets. 
          </div>

          <div style="display: flex;justify-content: space-between;" class="top10 width1461">
            

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  13
                </div>
              </div>
              <div class="title381">
                Invention patent-Be authorized
              </div>
            </div>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  32
                </div>
              </div>
              <div class="title381">
                Utility model patent-Be authorized
              </div>
            </div>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  12
                </div>
              </div>
              <div class="title381">
                Design patent-Be authorized
              </div>
            </div>

            <div style="display: flex;flex-direction: column;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: end;">
                <div class="title721">
                  40
                </div>
              </div>
              <div class="title381">
                Software copyright-Be authorized
              </div>
            </div>
          </div>

          <img src="./assets/img/c5.png" class="c5" />
        </div>

        <div id="pageFive" ref="pageFive" :style="{ height: fullHeight }" class="px29">
          <div >
            <div style="display: flex;" :style="{ height: fullHeight3 }">
              <img src="./assets/img/1.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/2.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/3.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/4.png" class="pic2 pc2 trans2" />
            </div>
            <div style="display: flex;" :style="{ height: fullHeight3 }">
              <img src="./assets/img/5.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/6.png" class="pic2 pc1 trans1" />
              <img src="./assets/img/7.png" class="pic22 pc2 trans2" />
            </div>
            <div style="display: flex;" :style="{ height: fullHeight3 }">
              <img src="./assets/img/9.png" class="pic2 pc3 trans3" />
              <img src="./assets/img/10.png" class="pic2 pc3 trans3" />
              <img src="./assets/img/11.png" class="pic2 pc3 trans3" />
              <img src="./assets/img/12.png" class="pic2 pc4 trans4" />
            </div>
          </div>
        </div>
      </div>


      <div class="bottom-black" id="pageFour" ref="pageFour">
        <div class="bottom-ori">
          <img src="./assets/mq_logo.png" class="bottom-logo">
          <div class="bottom-margin-left bottom-word">
            <div style="cursor: pointer;" @click="changeTabStatus(1)">
              Home
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="changeTabStatus(2)">
              Products solution
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="changeTabStatus(3)">
              Service and support
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="changeTabStatus(4)">
              About us
            </div>
            <div class="bottom-margin-top" style="cursor: pointer;" @click="showReport()">
              Member center
            </div>
          </div>

          <div class="bottom-word1">
            <div>
              Contact us
            </div>
            <div class="bottom-margin-top bottom-qrcode-word">
              Add.: Building 5#, No.58 Yaochi Road, Huzhou, Zhejiang, China
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              Tel: +86-400-0572-278
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              Fax: +86-572-2751277
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              Postcode: 313000
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              Contact: +8613567983061
            </div>
            <div class="bottom-margin-top-2 bottom-qrcode-word">
              Email：lym@mqcgm.com
            </div>
          </div>
        </div>
        <div class="bottom-ori icp-copyright left50" style="margin-top: 30px;">

          <div style="">
            <div style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="./assets/img/0.png" style="float:left;" />
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#ffffff;">
                浙公网安备 33059102000319号
              </p>
            </div>
          </div>

          <a href="https://beian.miit.gov.cn/#/Integrated/index" class="bottom-qrcode-word"
            style="margin-left:220px;color:#ffffff;opacity: 1">浙ICP备16013812号</a>

        </div>
        <div class="icp-copyright" style="bottom:20px;color:white;left: 43%;">Copyright ©2017 湖州美奇医疗器械有限公司</div>
        <img src="./assets/img/totop.png"
          style="width: 66px;height: 66px;margin-left: 272px;margin-top: 234px;cursor: pointer;" @click="goTop" />
      </div>
    </div>
  </div>
</template>
<script>

import Login from './view/Login'

import Vue from 'vue'
import { ACCESS_TOKEN } from './store/mutation-types'
import PDFModal from './components/PDFModal'
import { getAction } from './network/GetAndPost'

export default {
  name: 'MainPage',
  components: [Login, PDFModal],
  data() {
    return {
      customStyle: 'background: #ffffff',
      calcuHeight: '',
      sParams: {},
      qaurl: 'faq/list',
      QAList: [],
      expandIconPosition: 'right',
      swiperOptions: {
        slidesPerView: 1, // 显示个数
        direction: 'horizontal',
        loop: true,
        // 启用分页器
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: true
        }
      },
      menuStyle: {
        position: 'absolute',
        top: '0px',
        zIndex: 3,
        right: '0px',
        width: '438px',
        height: '100%',
        backgroundColor: 'white',
        display: 'none'
      },
      menuStyle1: {
        width: '325px',
        height: '100%',
        display: 'block',
        paddingLeft: '130px'
      },
      tStyle: {
        height: '100px',
        width: '500px',
        background: '#FF0000'
      },
      menu: {
        title: '首頁',
        children: [
          {
            title: `Today's Deals`,
            link: `/today`,
            children: []
          },
          {
            title: `Shop By Department`,
            children: [
              {
                title: `Amazon Music`,
                link: `/music`,
                children: []
              },
              {
                title: `CDs and Vinyl`,
                link: `/cds`,
                children: []
              }
            ]
          }
        ]
      },
      pageStatus: 1,
      readyStatus: 1,
      tabStatus: 1,
      aboutUsArray: ["关于我们", "发展历程", "企业文化", "资质荣耀", "关于团队", "销售渠道"],
      productArray: ["产品配件", "功能介绍", "产品优势", "佩戴流程", "监护系统"],
      downloadArray: ["美奇用户端", "美奇医生端"],
      menus: []
    }
  },
  computed: {
    fullHeight() {
      return window.innerHeight + 'px'
    },
    fullHeight3() {
      return window.innerHeight / 3 + 'px'
    },
  },
  methods: {
    isSelect(n) {
      if (n == this.tabStatus) {
        return true
      } else {
        return false
      }
    },
    isUnSelect(n) {
      if (n == this.tabStatus) {
        return false
      } else {
        return true
      }
    },
    getList() {
      getAction("http://manage.mqcgm.com/jeecg-boot/faq/list", this.sParams).then((res) => {
        if (res.success) {
          this.QAList = res.result.records
        }
      })
    },
    changeTabStatus(ts) {

      this.goTop()

      this.tabStatus = ts


    },
    goTop() {
      this.pageStatus = 1
      // 获取当前位置
      let c = window.pageYOffset
      // 计算滚动距离
      // 开滚
      this.scrollAnimation(c, 0)
    },
    selectColor(pos) {
      if (pos === 1) {

      } else if (pos === 2) {

      } else if (pos === 4) {

      }
    },
    showReport() {
      let a = Vue.ls.get(ACCESS_TOKEN)
      if (a === "" || a === null || a === undefined) {
        this.$router.push({ name: 'Login' })
      } else {
        this.$router.push({ name: 'personalMain' })
      }
    },
    showMenu() {
      this.menuStyle.display = 'block'
    },
    closeMenu() {
      this.menuStyle.display = 'none'
    },
    windowAddMouseWheel() {
      window.addEventListener('wheel', (e) => {
        // 直接传递滚动量（禁用防抖）
        window.scrollBy(0, e.deltaY)
      }, { passive: true })
    },
    /**
     * 单击事件自动向上或向下滚动一屏
     */
    pagingDown() {
      // 获取窗口高度
      let h = window.innerHeight

      let temp = 4;
      if (this.tabStatus == 1) {
        temp = 4
      } else if (this.tabStatus == 2) {
        temp = 8
      } else if (this.tabStatus == 3) {
        temp = 5
      } else if (this.tabStatus == 4) {
        temp = 7
      }
      if (this.pageStatus !== temp) {
        h = window.innerHeight
      } else {
        h = document.getElementById("pageFour").offsetHeight
      }
      if (this.pageStatus !== temp) {
        this.pageStatus = this.pageStatus + 1
      }

      // 获取当前位置
      let c = window.pageYOffset
      // 计算滚动距离
      // 开滚
      this.scrollAnimation(c, c + h)
    },
    pagingUp() {
      // 获取窗口高度
      let h = window.innerHeight
      let temp = 4;
      if (this.tabStatus == 1) {
        temp = 4
      } else if (this.tabStatus == 2) {
        temp = 8
      } else if (this.tabStatus == 3) {
        temp = 5
      } else if (this.tabStatus == 4) {
        temp = 7
      }
      if (this.pageStatus !== temp) {
        h = window.innerHeight
      } else {
        h = document.getElementById("pageFour").offsetHeight
      }
      if (this.pageStatus !== 1) {
        this.pageStatus = this.pageStatus - 1
      }
      // 获取当前位置
      let c = window.pageYOffset
      // 计算滚动距离
      // 开滚
      this.scrollAnimation(c, c - h)


    },
    /**
     * 动画垂直滚动到页面指定位置
     * @param { Number } currentY 当前位置
     * @param { Number } targetY 目标位置
     */
    scrollAnimation(currentY, targetY) {
      // 获取当前位置方法
      const duration = 1000
      const startTime = Date.now()

      const animate = () => {
        const progress = Math.min((Date.now() - startTime) / duration, 1)
        window.scrollTo(0, currentY + (targetY - currentY) * progress)
        if (progress < 1) requestAnimationFrame(animate)
      }
      requestAnimationFrame(animate)
    },
    changeQRCode(param) {
      if (param === 1) {
        this.download = Download
      } else if (param === 2) {
        this.download = Docker
      }
    }
  },
  mounted() {
    this.windowAddMouseWheel()
    this.getList()
    this.calcuHeight = window.innerHeight - this.$refs.pnavigation.offsetHeight + 'px'
  }
}
</script>

<style scoped>
#app {
  height: auto;
  /* 改为自适应高度 */
  overflow-y: auto;
  /* 启用原生滚动 */
  scroll-behavior: smooth;
  will-change: transform;
  /* 启用GPU加速 */
}

.zs {
  margin-top: 50px;
  color: #FFFFFF;
  font-size: 26px;
}

.menuStyle1 {
  width: 455px;
  height: 100%;
  display: block;
  padding-left: 130px
}

.bottom-top {
  margin-top: 132px;
}

.bottom-margin-left-1 {
  margin-left: 30px;
}

.bottom-margin-left {
  margin-left: 205px;
}

.bottom-qrcode-download {
  font-size: 16px;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 22px;
}

.bottom-qrcode-word {
  font-size: 12px;
  font-weight: 300;
  color: #FFFFFF;
  line-height: 17px;
  opacity: 0.6;
}

.bottom-qrcode {
  width: 95px;
  height: 95px;
}

.bottom-margin-top {
  margin-top: 30px;
}

.bottom-margin-top-2 {
  margin-top: 20px;
}

.bottom-word {
  font-size: 16px;
  font-weight: 300;
  color: #FFFFFF;
  margin-left: 205px;
  margin-top: 132px;
}

.bottom-word1 {
  font-size: 16px;
  font-weight: 300;
  color: #FFFFFF;
  margin-left: 271px;
  margin-top: 132px;
}

.bottom-ori {
  display: flex;
  flex-direction: row;
}

.icp-copyright {
  bottom: 50px;
  position: absolute;
}

.left50 {
  left: 34%
}

.swiper-container {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  overflow-y: hidden;
  text-align: center;
  font-size: 18px;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}


.bottom-black {
  width: 100%;
  height: 483px;
  display: flex;
  position: relative;
  background: #1D1E24;
}

.vip-center {
  padding: 7px 14px;
  width: fit-content;
  height: fit-content;
  background: #212121;
  border-radius: 19px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 195px;
}

.go-english {
  padding: 7px 14px;
  width: fit-content;
  height: fit-content;
  background: #212121;
  border-radius: 19px;
  display: flex;
  align-items: center;
  position: absolute;
  right: 340px;
}

.vip-word {
  cursor: pointer;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}

.vip-word-1 {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 22px;
}

.img_bg {
  width: 100%;
  height: 100%;
}

.img_bg1 {
  width: 435px;
  height: 500px;
}

.title {
  position: absolute;
  top: 40px;
  width: 100%;
  height: 36px;
  display: flex;
  align-items: center;
}



.logo {
  position: absolute;
  top: 0px;
  left: 130px;
  width: 231px;
  height: 36px;
}

.bottom-logo {
  margin-top: 127px;
  margin-left: 221px;
  width: 231px;
  height: 36px;
}

.menu {
  position: absolute;
  right: 129px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

.center-text {
  top: 280px;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.center-name {
  width: 188px;
  height: 79px;
}

.center-slogan {
  margin-top: 33px;
  font-size: 30px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 42px;
}

.center-button-layout {
  margin-top: 110px;
}

.center-button-left {
  width: 189px;
  height: 62px;
  cursor: pointer;
}

.center-button-right {
  width: 189px;
  height: 62px;
  margin-left: 40px;
  cursor: pointer;
}

.next_page_arrow {
  position: absolute;
  width: 34px;
  height: 34px;
  left: 50%;
  transform: translate(-50%);
  bottom: 60px;
  cursor: pointer;
}

.temp_word {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 250px;
  cursor: pointer;
  font-size: 20px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 42px;
}

.remark_number {
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 60px;
  cursor: pointer;
  font-size: 10px;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 42px;
}

.page_title {
  margin-top: 106px;
  font-size: 40px;
  font-weight: 500;
  color: #333333;
  line-height: 56px;
}

.page_sub_title {
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #666666;
  line-height: 22px;
  text-decoration: none;
}

.right-title {
  margin-bottom: 50px;
  font-size: 18px;
  font-weight: 500;
  color: #666666;
  line-height: 25px;
  cursor: pointer;
}

.active {
  color: #009CEE
}

.pnavigation {
  height: 78px;
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.plogo {
  margin-left: 223px;
  height: 30px;
  width: 180px;
}

.pswiper {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.selectTitle {
  font-weight: 600;
  font-size: 16px;
  color: #009CEE;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}

.unSelectTitle {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}

.marginLeft240 {
  margin-left: 240px;
}

.marginLeft68 {
  margin-left: 68px;
}

.height867 {
  height: 867px
}

.icon123 {
  height: 64px;
  width: 64px;
  position: absolute;
  bottom: 86px;
  left: 221px;
  cursor: pointer;
}

.padding1 {
  padding: 127px 221px 92px 221px
}

.width534 {
  width: 534px;
}

.title36 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.title361 {
  font-weight: 500;
  font-size: 36px;
  color: #31AEEF;
}

.px311 {
  font-weight: 500;
  font-size: 36px;
  color: #009CEE;
  line-height: 40px;
}

.width425 {
  width: 425px;
  margin-top: 86px;
  margin-left: 50px;
}

.xxx2 {
  margin-top: 6px;
}

.top36 {
  margin-top: 36px;
}

.point {
  width: 8px;
  height: 8px;
  background: #009CEE;
  opacity: 0.8;
  margin-top: 10px;
  border-radius: 8px;
}

.xxx1 {
  font-weight: 500;
  font-size: 22px;
  color: #333333;
  line-height: 26px;
}

.top24 {
  margin-top: 24px;
}

.xxx3 {
  font-weight: 400;
  font-size: 18px;
  color: #666666;
  line-height: 26px;
  margin-left: 4px;
}

.zword {
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  margin-left: 6px;
}

.subtitle {
  font-weight: 500;
  font-size: 36px;
  color: #009CEE;
}

.content1 {
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  margin-top: 30px;
  line-height: 28px;
}

.content11 {
  font-weight: 500;
  font-size: 16px;
  color: #666666;
  margin-top: 20px;
  line-height: 28px;
}

.content2 {
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  margin-top: 18px;
  line-height: 28px;
}

.knowmore {
  cursor: pointer;
  width: 150px;
  height: 54px;
  background-size: cover;
  margin-top: 48px;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;

}

.pic1 {
  height: 558px;
  width: 904px;
  margin-left: 40px;
}

.title72 {
  font-weight: 500;
  font-size: 52px;
  color: #333333;
  line-height: 1;
}

.title52 {
  font-weight: 500;
  font-size: 52px;
  color: #333333;
  line-height: 1;
}

.title16 {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
}

.title38 {
  font-weight: 300;
  font-size: 16px;
  color: #333333;
  margin-top: 38px;
}

.width1212 {
  width: 1212px;
  height: 100%;
}

.width333 {
  width: 334px;
  margin-top: 170px;
  margin-left: 154px;
}

.width433e {
  width: 433px;
  margin-top: 141px;
  margin-left: 54px;
}

.width333e {
  width: 439px;
  margin-top: 97px;
  margin-left: 50px;
}

.content14 {
  font-weight: 500;
  font-size: 14px;
  color: #666666;
  margin-top: 30px;
  line-height: 28px;
}

.content14e {
  font-weight: 400;
  font-size: 16px;
  color: #666666;
  line-height: 28px;
}

.content15e {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  margin-top: 10px;
  line-height: 28px;
}

.width150 {
  width: 150px;
  height: 54px;
  background-size: cover;
  margin-top: 30px;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.padding293 {
  padding-top: 293px;
}

.width453 {
  margin-left: 221px;
  width: 453px;
}

.title50 {
  font-weight: 500;
  font-size: 50px;
  color: #333333;
  line-height: 68px;
}



.subtitle22 {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  margin-top: 17px;
  line-height: 28px;
}

.content18 {
  font-weight: 300;
  font-size: 18px;
  color: #666666;
  margin-top: 0px;
  line-height: 28px;
}

.content22 {
  font-weight: 400;
  font-size: 22px;
  color: #333333;
  margin-top: 17px;
  line-height: 28px;
}

.width334 {
  width: 334px;
  margin-top: 170px;
  margin-left: 221px;
  margin-right: 154px;
}

.subtitle16 {
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.width1478 {
  width: 1478px;
  height: 807px
}

.title36top90 {
  margin-top: 90px;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.top12title24 {
  margin-top: 12px;
  font-weight: 300;
  font-size: 24px;
  color: #333333;
}

.width1200 {
  width: 1200px;
  height: 675px;
  margin-top: 40px;
}

.top90 {
  display: flex;
  margin-top: 90px;
}

.width354 {
  height: 354px;
  width: 354px;
}

.things {
  font-weight: 500;
  font-size: 24px;
  color: #333333;
  margin-top: 40px;
}

.left20 {
  margin-left: 20px;
}

.height70 {
  width: 100%;
  height: 70px;
  margin-top: 36px;
}

.height867r {
  width: 100%, ;
  height: 782px;
  position: relative
}

.height472 {
  height: 782px;
  width: 1920px;
  background-size: cover;
  background-position: center;
  padding-top: 177px;
  display: flex;
  flex-direction: column;
}

.left221 {
  margin-left: 221px;
}

.subtitle24 {
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  margin-top: 20px;
  line-height: 28px;
}

.height400 {
  height: 400px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.f24t12 {
  font-weight: 300;
  font-size: 24px;
  color: #333333;
  margin-top: 12px;
}

.top48 {
  margin-top: 48px;
}

.width392 {
  width: 392px;
  height: 154px;
  background: #D7E7FF;
  border-radius: 16px;
}

.f24 {
  font-weight: 300;
  font-size: 24px;
  color: #333333;
}

.f16 {
  font-weight: 300;
  font-size: 16px;
  color: #333333;
}

.f36t130 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  margin-top: 130px;
}

.height393 {
  height: 393px;
  width: 479px;
}

.f24t16 {
  font-weight: 300;
  font-size: 24px;
  color: #333333;
  margin-top: 16px;
}

.f16t8 {
  font-weight: 300;
  font-size: 16px;
  color: #333333;
  margin-top: 8px;
}

.unknow {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 392px;
  height: 290px;
  background: #D7E7FF;
  border-radius: 16px;
}

.unknow1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 392px;
  height: 219px;
  background: #D7E7FF;
  border-radius: 16px;
}

.unknow2 {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 219px;
  background: #D7E7FF;
  border-radius: 16px;
}

.t36h82w82 {
  margin-top: 36px;
  width: 82px;
  height: 82px;
}

.f24t18 {
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  margin-top: 18px;
}

.left28 {
  margin-left: 28px;
}

.px1 {
  width: 82px;
  height: 82px;
  margin-left: 155px;
}

.px2 {
  margin-left: 43px;
  width: 382px;
  height: 56px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 350;
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.px3 {
  width: 162px;
  height: 162px;
  margin-left: 310px;
}

.px4 {
  width: 100%;
  background-size: cover;
  padding-top: 82px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.f36 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 68px;
}

.f36h50 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 50px;
}

.top20 {
  width: 1478px;
  height: 391px;
  margin-top: 20px;
}

.content12 {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  width: 1478px;
  line-height: 28px;
  margin-top: 16px;
}

.top76 {
  margin-top: 76px;
}

.top56 {
  margin-top: 50px;
}

.f36e {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
  line-height: 50px;
}

.px5 {
  width: 860px;
  height: 58px;
  border-radius: 43px;
  background-color: #F5FAFF;
  font-weight: 300;
  font-size: 16px;
  color: #999999;
  display: flex;
  align-items: center;
}

.px6 {
  width: 20px;
  height: 20px;
  margin-left: 25px;
}

.px7 {
  width: 860px;

  font-weight: 300;
  font-size: 16px;
  color: #333333;
  border: none;
  margin-right: 30px;
  margin-left: 10px;
}

.px8 {
  margin-top: 75px;
  width: 1478px;
}

.px9 {
  font-weight: 300;
  font-size: 16px;
  color: #009CEE;
}

.px10 {
  height: 867px;
  width: 100%;
  background-size: cover;
  padding-top: 82px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.px11 {
  font-weight: 500;
  font-size: 50px;
  color: #333333;
  line-height: 68px;
}

.px12 {
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  margin-top: 20px;
  line-height: 28px;
}

.px13 {
  width: 425px;
  margin-top: 76px;
  margin-left: 62px;
}

.top38 {
  margin-top: 38px;
}

.px14 {
  background-size: cover;
  padding-top: 118px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.px15 {
  color: #333333;
  font-size: 30px;
  font-weight: 600;
}

.px16 {
  margin-left: 1143px;
  padding: 73px 61px 73px 61px;
  width: 460px;
  border-radius: 20px;
  background-color: #FFFFFF;
}

.px17 {
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.px18 {
  margin-top: 30px;
  font-size: 16px;
  color: #333333;
}

.px19 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px20 {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}

.px21 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px22 {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}

.px23 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px24 {
  margin-top: 20px;
  font-size: 16px;
  color: #333333;
}

.px25 {
  margin-top: 0px;
  font-size: 15px;
  color: #666666;
}

.px26 {
  width: 100%;
  padding-top: 40px;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.px27 {
  font-weight: 500;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
  line-height: 22px;
  width: 1461px;
  text-align: center;
}

.px28 {
  width: 1400px;
  margin-top: 40px;
  margin-bottom: 50px;
}

.height500 {
  height: 500px;
}

.px29 {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.px30 {
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  margin-top: 20px;
  line-height: 28px;
  width: 1202px;
}

.top60 {
  margin-top: 60px;
}

.top28 {
  margin-top: 28px;
}

.px31 {
  font-weight: 500;
  font-size: 36px;
  color: #009CEE;
}

.px31e {
  font-weight: 500;
  font-size: 36px;
  color: #009CEE;
  margin-top: 20px;
}

.top100 {
  padding-top: 100px;
}

.px32 {
  font-weight: 500;
  font-size: 36px;
  color: #FFFFFF;
}

.px33 {
  margin-top: 12px;
  width: 833px;
  height: 66px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 300;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 33px;
  text-align: center;
}

.left60 {
  margin-left: 60px;
}

.swiper-pagination {
  position: absolute;
  bottom: 60px;
}

.top80 {
  margin-top: 80px;
}

.top30 {
  margin-top: 30px;
}

.top18 {
  margin-top: 18px;
}

.zpic {
  width: 30px;
  height: 30px;
}

.width447 {
  width: 447px;
  margin-top: 145px;
  margin-left: 221px;
  margin-right: 41px;
}

.top66 {
  width: 1478px;
  margin-top: 26px;
  justify-content: space-between;
}

.c1 {
  width: 40px;
  height: 40px;
}

.c2 {
  color: #333333;
  font-size: 18px;
}

.c3 {
  color: #999999;
  font-size: 16px;
}

.c5 {
  margin-top: 32px;
  width: 1461px;
  height: 574px;
}

.width1348 {
  width: 1348px;
}

.width1461 {
  width: 1461px;
}

.title721 {
  font-weight: 500;
  font-size: 52px;
  color: #333333;
  line-height: 40px;
}

.title381 {
  font-weight: 350;
  font-size: 16px;
  color: #333333;
  margin-top: 16px;
}

.top10{
  margin-top: 10px;
}


.pic2 {
  flex: 1;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease-in-out;
  /* 新增过渡效果 */
}

.pic22 {
  flex: 2;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease-in-out;
  /* 新增过渡效果 */
}

.trans1 {
  transform-origin: 0 0;
}

.trans2 {
  transform-origin: 100% 0;
}

.trans3 {
  transform-origin: 0 100%;
}

.trans4 {
  transform-origin: 100% 100%;
}

/* 图片悬停时的样式 */
.pc1:hover {
  transform: scale(2);
  transform-origin: 0 0;
  /* 保持原有代码不变 */
}

/* 图片悬停时的样式 */
.pc2:hover {
  transform: scale(2);
  transform-origin: 100% 0;
  /* 保持原有代码不变 */
}

/* 图片悬停时的样式 */
.pc3:hover {
  transform: scale(2);
  transform-origin: 0 100%;
  /* 保持原有代码不变 */
}

/* 图片悬停时的样式 */
.pc4:hover {
  transform: scale(2);
  transform-origin: 100% 100%;
  /* 保持原有代码不变 */
}
</style>



// WEBPACK FOOTER //
// src/MainPage.vue